import { type CampaignInfo, type CouponInfo } from '@/typings/reward-task'
import ApiClient from '@/utils/api-client'
import { getBaseURL } from '@/utils/common'

export function getCampaignTasks(): Promise<CampaignInfo> {
  return ApiClient.get(`${getBaseURL()}/campaign/guide/tasks`)
}

export function claimCampaignReward(): Promise<CampaignInfo> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/claim-reward`)
}

export function validateCampaign(): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/validate`)
}

export function assignGuideTask(): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/guide/assign`)
}

export function getCoupon(): Promise<CouponInfo[]> {
  return ApiClient.get(`${getBaseURL()}/campaign/coupons/available`)
}

export function getFbclid(device_id: string): Promise<{ fbclid: string }> {
  return ApiClient.get(`${getBaseURL()}/campaign/public/facebook/link?device_id=${device_id}`)
}

export function setFbclid(device_id: string, fbclid: string, expire_in = 3600 * 24 * 30): Promise<void> {
  return ApiClient.post(`${getBaseURL()}/campaign/public/facebook/link`, { device_id, fbclid, expire_in })
}

export function reward(key: string): Promise<CouponInfo> {
  return ApiClient.post(`${getBaseURL()}/campaign/marketing/reward`, { key }, false)
}
